import React from "react";
import { Box, Text } from "@chakra-ui/react";
export function StatsItemValue(props) {
    return (React.createElement(Box, { mt: 1 },
        React.createElement(Text, { as: "span", fontSize: "lg", fontWeight: "semibold", color: "text.primary", ...props })));
}
